import type { Store } from 'effector';
import { useStore, useStoreMap } from 'effector-react';

function useEditingStore<State, Result>({
  $data,
  dataFn,
  $editing,
}: {
  $data: Store<State>;
  dataFn: (state: State) => Result;
  $editing: Store<Exclude<Result, undefined> | null>;
}) {
  const data = useStoreMap({
    store: $data,
    keys: [],
    fn: dataFn,
  });
  const editingData = useStore($editing);
  return editingData === null ? data : editingData;
}

export default useEditingStore;
